import {
  camelCase2dense,
  camelCase2SnakeCase,
  snakeCase2camelCase,
  snakeCase2dense,
} from '../utils/format'

import { query, hashQuery } from '@didi/webx-js'

/**
 * @typedef URLQueries
 * @property {('en-US' | 'zh-CN' | 'zh-HK')} lang - 语言
 * @property {string} city_id - 城市 ID
 * @property {string} cityid - 城市 ID
 * @property {string} trip_cityid - 城市 ID
 * @property {string} lat - lat
 * @property {string} lng - lng
 * @property {string} businessType - businessType
 * @property {string} eventParams - 算法事件参数
 */

/**
 * @type {URLQueries}
 */
export const URLQueries = {
  /**
   * 兼容方法
   * @param {string} key - Query key
   * @return {string}
   */
  getQuery(key) {
    switch (true) {
      case this[key] !== undefined:
        return this[key]
      case /_/.test(key):
        return this[snakeCase2camelCase(key)] || this[snakeCase2dense(key)]
      case /[A-Z]/.test(key):
        return this[camelCase2SnakeCase(key)] || this[camelCase2dense(key)]
    }
  },
  ...query(),
  ...hashQuery(),
}

/**
 * 获取url上的biz_extra参数
  形如：biz_extra: "{"clickid: "", "adid": "", "creativeid": "", "creativetype": ""}"
*/
export const getUrlBizExtraParams = () => {
  const bizExtra = URLQueries.getQuery('biz_extra')
  return (bizExtra && JSON.parse(bizExtra)) || {}
}
